<template>
  <div class="selection-page container">
    <div class="selection-page__title">
      <h1 class="title">Моя Підбірка</h1>
      <p class="sub-title">
        Ви можете керувати вподобаними об’єктами, видаляти та сортувати.
      </p>
    </div>
    <Sorting :count="favoriteFlats.length" title="об’єктів у твоїй підбірці" />
    <SelectedApartment
      v-for="item in sortedFlats"
      :key="item.id"
      :item="item"
    />
    <div class="selected-mobile-image-bg hidden-sm-and-up">
        <img src="@/assets/images/mobile/Subject.png" alt="" />
      </div>
    <!--    background-->
    <div class="hidden-xs-only">
      <div class="selected-main-img">
        <img src="@/assets/images/selected-main-img.png" alt="" />
      </div>

      <!-- 600 - offsetTop , (750, 836) - height of (left, right) image,  700 design offset between circles  -->
      <div
        class="selected-left"
        v-for="(_, index) in Math.round(docHeight / 1000)"
        :style="{
          top: 2986 * index + 600 + 'px',
        }"
      >
        <img src="@/assets/images/left-circle.png" alt="" />
      </div>
      <div
        class="selected-right"
        v-for="(_, index) in Math.round(docHeight / 1000)"
        :style="{
          top: 2986 * index + 2050 + 'px',
        }"
      >
        <img src="@/assets/images/right-circle.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/common/Header'
import Apartment from '@/components/home/apartment/Apartment'
import SelectedApartment from '@/components/Selected/SelectedApartment'
import Sorting from '@/components/common/Sorting'
import { mapGetters } from 'vuex'

export default {
  name: 'Favorite',
  components: { SelectedApartment, Apartment, Header, Sorting },

  computed: {
    ...mapGetters({
      favoriteFlats: 'getFavoriteFlatList',
      docHeight: 'getDocumentHeight',
    })
    ,
    sortedFlats() {
      return this.favoriteFlats.sort((a , b) => {
        if (a.is_sort_up) return -1;
        if (a.is_sort_down) return 1;
        if (b.is_sort_down) return -1;
        return 0;
      })
    }
  },
  methods: {},
}
</script>
